import React from "react";
import { useEffect, useState } from "react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import axios from "axios";

function WeeklyStatistics() {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [header, setHeader] = useState([]);

  useEffect(() => {
    setLoading(true);

    axios
      .post(
        "https://a9s48sduha.execute-api.ap-northeast-1.amazonaws.com/v1/weekly/reports/statistics"
      )
      .then(function (response) {
        const result = response.data;
        const payload = result.data ?? (typeof result.body === "string"
          ? JSON.parse(result.body)
          : result.body);
        if (String(result.status).toUpperCase() !== "SUCCESS") {
          throw new Error(payload?.message || result.message || "Unable to load statistics.");
        }
        const groups = {
          M: payload?.Male ?? payload?.M ?? [],
          F: payload?.Female ?? payload?.F ?? [],
        };
        if (!payload || !Array.isArray(groups.M) || !Array.isArray(groups.F)) {
          throw new Error("Invalid statistics response.");
        }
        const normalizeRow = (row) => {
          const allotted = row.Allotted ?? row.Total;
          const present = row.Present ?? row.Reported;
          if ([allotted, present, row.Leave, row.Absent].some(value => value == null)) {
            throw new Error("Weekly attendance summary is unavailable. Please update the statistics API.");
          }
          return {
            "Zone Name": row.name ?? row["Zone Name"],
            Allotted: allotted,
            Present: present,
            Leave: row.Leave,
            Absent: row.Absent,
          };
        };
        setData({ M: groups.M.map(normalizeRow), F: groups.F.map(normalizeRow) });
        setHeader(groups.M.length + groups.F.length > 0
          ? ["Zone Name", "Allotted", "Present", "Leave", "Absent"] : []);
      })
      .catch(function (error) {
        setError(error.message || "Unable to load statistics.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <>
      <div className="grid grid-cols-12 gap-5 printable">
        <div className="page-title">Weekly attendance summary</div>
        <div className="text-lg uppercase col-span-12">
          {/* Time in HH:MM */}
          Date: {new Date().toLocaleDateString()} &nbsp; Time:{" "}
          {new Date().toLocaleTimeString()}
        </div>
        {loading && <div className="col-span-12">Loading...</div>}
        {!loading && error && <div role="alert" className="col-span-12">{error}</div>}
        {!loading && !error && header.length > 0 && (
          <>
            <div className="col-span-12 text-right skipprint">
              {
                <ReactHTMLTableToExcel
                  filename={"Weekly Statistics"}
                  sheet={"Weekly Statistics"}
                  table="table1"
                  buttonText="  Excel"
                  className="fas fa-download text-green-600"
                >
                  <button>
                    <img
                      src="/images/icons/excel.png"
                      alt="Excel"
                      className="h-5 w-5 cursor-pointer"
                    />{" "}
                  </button>
                </ReactHTMLTableToExcel>
              }
            </div>
            <table
              className="table-auto col-span-12 border-collapse"
              id="table1"
            >
              <thead>
                <tr>
                  <th className="border px-4 py-2" colSpan={header.length}>
                    Male
                  </th>
                </tr>
                <tr>
                  {header.map((item) => {
                    return (
                      <th className="border px-4 py-2" key={item}>
                        {item}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {data &&
                  data["M"] &&
                  data["M"].length > 0 &&
                  data["M"].map((item, index) => {
                    return (
                      <tr
                        key={item["zoneId"] ?? item.name ?? index}
                        className={
                          /^(total|grand total)$/i.test(item.name || item["Zone Name"] || "")
                            ? "font-bold text-green-600"
                            : ""
                        }
                      >
                        {header.map((key) => {
                          return (
                            <td
                              className={
                                "border px-4 py-2 " +
                                (key === "Zone Name" || key === "name" ? "text" : "")
                              }
                              key={key}
                            >
                              {item[key]}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}

                <tr>
                  <th className="border px-4 py-2" colSpan={header.length}>
                    Female
                  </th>
                </tr>
                {data &&
                  data["F"] &&
                  data["F"].length > 0 &&
                  data["F"].map((item, index) => {
                    return (
                      <tr
                        key={item["zoneId"] ?? item.name ?? index}
                        className={
                          /^(total|grand total)$/i.test(item.name || item["Zone Name"] || "")
                            ? "font-bold text-green-600"
                            : ""
                        }
                      >
                        {header.map((key) => {
                          return (
                            <td
                              className={
                                "border px-4 py-2 " +
                                (key === "Zone Name" || key === "name" ? "text" : "")
                              }
                              key={key}
                            >
                              {item[key]}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </>
        )}
        {!loading && !error && header.length === 0 && (
          <div className="col-span-12">No data found</div>
        )}
      </div>
    </>
  );
}
export default WeeklyStatistics;
